<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="原设备MAC地址" prop="macAddressList">
        <div
          v-for="(mac, index) in form.macAddressList"
          :key="index"
          style="margin-bottom: 8px; display: flex; align-items: center"
        >
          <a-input
            v-model="form.macAddressList[index]"
            :placeholder="`请输入第${index + 1}个MAC地址，格式：XX:XX:XX:XX:XX:XX`"
            :maxLength="17"
            style="flex: 1; margin-right: 8px"
            @input="(e) => formatMacAddress(e, index)"
          />
          <a-button
            v-if="form.macAddressList.length > 1"
            type="danger"
            size="small"
            icon="delete"
            @click="removeMacAddress(index)"
          >
            删除
          </a-button>
        </div>
        <a-button type="dashed" icon="plus" block @click="addMacAddress" style="margin-top: 8px">
          添加MAC地址
        </a-button>
      </a-form-model-item>

      <a-form-model-item label="确认收货图片" prop="receiptImages">
        <file-upload
          :file="form.receiptImages"
          type="image"
          :count="3"
          pathSrc="repair/receipt"
          :autoCropWidth="400"
          :autoCropHeight="300"
          @input="handleImageChange"
        />
        <div class="upload-tips">请上传确认收货图片，支持jpg、jpeg、png、gif格式，最多3张，每张不超过5MB（选填）</div>
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入备注（选填）" :rows="3" :maxLength="150" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 开始维修 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { startRepair } from '@/api/fix/devRepair'
import FileUpload from '@/components/FileUpload'

export default {
  name: 'StartRepair',
  components: {
    FileUpload,
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '设备返修-开始维修',
      open: false,
      showLoading: false,

      form: {
        id: undefined,
        macAddressList: [''],
        receiptImages: [],
        remark: '',
      },

      rules: {
        macAddressList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请至少输入一个MAC地址'))
                return
              }
              const validMacList = value.filter((mac) => mac && mac.trim())
              if (validMacList.length === 0) {
                callback(new Error('请至少输入一个MAC地址'))
                return
              }
              const macPattern = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
              for (let i = 0; i < validMacList.length; i++) {
                if (!macPattern.test(validMacList[i])) {
                  callback(new Error(`第${i + 1}个MAC地址格式不正确，应为XX:XX:XX:XX:XX:XX`))
                  return
                }
              }
              callback()
            },
            trigger: 'change',
          },
        ],
        receiptImages: [{ required: false }],
        remark: [{ required: false, message: '请输入备注', trigger: 'blur' }],
      },
    }
  },
  methods: {
    onCloseConfirm(callback) {
      const that = this
      this.$confirm({
        title: '是否确认关闭？未保存的数据将丢失',
        onOk() {
          callback && callback()
          that.reset()
        },
        onCancel() {},
      })
    },

    addMacAddress() {
      this.form.macAddressList.push('')
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField('macAddressList')
      })
    },

    removeMacAddress(index) {
      this.form.macAddressList.splice(index, 1)
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField('macAddressList')
      })
    },

    formatMacAddress(e, index) {
      let value = e.target ? e.target.value : e
      if (!value) {
        this.$set(this.form.macAddressList, index, '')
        return
      }
      value = value.replace(/[^0-9A-Fa-f:-\s]/g, '')
      const cleanValue = value.replace(/[:-\s]/g, '').toUpperCase()
      const limitedValue = cleanValue.substring(0, 12)
      const formatted = limitedValue.match(/.{1,2}/g) || []
      const result = formatted.join(':')
      this.$set(this.form.macAddressList, index, result)
    },

    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },

    reset() {
      this.form = {
        id: undefined,
        macAddressList: [''],
        receiptImages: [],
        remark: '',
      }
      this.$refs.form && this.$refs.form.clearValidate()
    },

    init(record) {
      this.reset()
      this.form.id = record.id
      if (record.macAddressList && Array.isArray(record.macAddressList) && record.macAddressList.length > 0) {
        this.form.macAddressList = [...record.macAddressList]
      } else if (record.macAddress) {
        this.form.macAddressList = [record.macAddress]
      }
      this.open = true
    },

    handleImageChange(images) {
      this.form.receiptImages = images || []
    },

    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true

          const validMacList = this.form.macAddressList.filter((mac) => mac && mac.trim())

          const submitData = {
            id: this.form.id,
            macAddressList: validMacList,
            receiptImages:
              this.form.receiptImages && this.form.receiptImages.length > 0 ? this.form.receiptImages.join(',') : '',
            remark: this.form.remark || '',
          }

          startRepair(submitData)
            .then((response) => {
              this.$message.success('开始维修操作成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .catch(() => {})
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop && this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.upload-tips {
  color: #999;
  font-size: 12px;
  margin-top: 8px;
}

.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
